export const APOLLO_CLIENT_NAME = "ambassador-dashboard-ui";
export const APOLLO_CLIENT_VERSION = window.env?.VERSION ?? "unknown";

export const AUTH_TRANSFER = "AUTH_TRANSFER";
export const IS_EMBEDDED = window !== window.parent;
export const TRANSFER_PARENT_PARAMS = "TRANSFER_PARENT_PARAMS";
export const MIXPANEL = "mixpanel";

// Customise degree level and year of study
export const LD_CUSTOMISE_DEGREE_LEVEL_AND_YEAR = "ub-university-dashboard-customise-degree-level-yearofstudy";

// Empower Decision Making by suggesting Next Best Action to Ambassador - Version 1
export const EDM_NBA_V1 = "ub-ambassador-edm-nba-v1";
export const EDM_NBA_V1_DEFAULT_VALUE = false;

// New Ambo App Banner
export const LD_NEW_AMBO_APP_BANNER_FEATURE_FLAG = "ub-ambassador-show-new-ambo-app-download-banner";

// SSO
export const IS_SSO_ENABLED = "ub-ambassador-sso";
export const IS_SSO_ENABLED_DEFAULT_VALUE = false;
export const SSO_REDIRECT_TIMEOUT = 2250;
export const AUTH_STATE_UNKNOWN = "UNKNOWN";
export const AUTH_STATE_NON_SSO = "NON_SSO";
export const AUTH_STATE_SSO = "SSO";
export const ACVL_APPLICATION_ID = "ambassador";

export const COOKIE_CATEGORIES_VALUES = {
    ALL: "all",
    NECESSARY: "necessary",
    PERFORMANCE: "performance",
    ANALYTICS: "analytics",
    MARKETING: "marketing",
    FUNCTIONAL: "functional",
    STATISTICS: "statistics",
    TARGETING: "targeting",
    SOCIAL: "social",
};

export const COOKIE_CATEGORIES = new Map([
    [COOKIE_CATEGORIES_VALUES.ALL, [MIXPANEL]],
    [COOKIE_CATEGORIES_VALUES.NECESSARY, []],
    [COOKIE_CATEGORIES_VALUES.PERFORMANCE, []],
    [COOKIE_CATEGORIES_VALUES.ANALYTICS, [MIXPANEL]],
    [COOKIE_CATEGORIES_VALUES.MARKETING, []],
    [COOKIE_CATEGORIES_VALUES.FUNCTIONAL, []],
    [COOKIE_CATEGORIES_VALUES.STATISTICS, [MIXPANEL]],
]);

// Danger : Don't change this Map. This is based on one trust cookie categories.
export const ONE_TRUST_COOKIE_LIST_ID_MAP = {
    C0001: COOKIE_CATEGORIES_VALUES.NECESSARY,
    C0002: COOKIE_CATEGORIES_VALUES.PERFORMANCE,
    C0003: COOKIE_CATEGORIES_VALUES.FUNCTIONAL,
    C0004: COOKIE_CATEGORIES_VALUES.TARGETING,
    C0005: COOKIE_CATEGORIES_VALUES.SOCIAL,
    UNI01: COOKIE_CATEGORIES_VALUES.ANALYTICS,
};
